(function(app) {

    app.provider("custodianApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(custodianId) {
                            return crmApiGateway.get("/Custodians/" + custodianId);
                        }

                        service.getCustodians = function() {
                            return crmApiGateway.getArray("/Custodians");
                        }

                        service.create = function(custodian) {
                            return crmApiGateway.post("/Custodians", custodian);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line